import { clear, get, set } from '@separate/utilities/tokens';

const INELIGIBLE_STATES = ['UT', 'VT', 'WA'];
const PREMIUM_REDIRECT = 'premiumRedirect';

export function isStateEligible(state) {
  return !INELIGIBLE_STATES.includes(state);
}

// For the moment this is the one value I've observed that Stripe sends back to us when a payment has been missed.
// I have no idea if this is exhaustive though, so I'm encapsulating the Stripe specific details in this little
// helper function.  We can build this out to be an includes if there are more values to match.
export function isSubscriptionPastDue(subscription) {
  return subscription?.status === 'past_due';
}

// Similarly here, I _believe_ active is the only possible status for being in good standing.  We want true here
// as long as the subscription is live, whether in good standing or not.
export function isSubscriptionActive(subscription) {
  return (
    subscription?.status === 'active' || isSubscriptionPastDue(subscription)
  );
}

export function isSubscriptionLegacy(subscription) {
  return !subscription?.last4 && isSubscriptionActive(subscription);
}

export function clearPremiumRedirect() {
  clear(PREMIUM_REDIRECT);
}

export function getPremiumRedirect() {
  return get(PREMIUM_REDIRECT);
}

export function setPremiumRedirect(url) {
  set(PREMIUM_REDIRECT, url, null);
}
